(function (angular) {
    'use strict';

    angular.module('forms')
        /**
         *
         */
        .controller('viewFormCodeModal',
        ['growlService', '$uibModalInstance', '$timeout', 'form', '$scope', '$stateParams', 'portalConfig', function ( growlService, $uibModalInstance, $timeout, form, $scope, $stateParams, portalConfig) {

            $timeout(function () {
                var cm = angular.element(document.querySelector('.CodeMirror'));
                cm[0].CodeMirror.refresh();
            }, 0);

            $scope.cancel = function () {
                $uibModalInstance.close('cancel');
            };

            $scope.form = form;

            var apiSpaceId =  $stateParams.pickedApiSpaceId;
            var formUrlBase = portalConfig.formUrlBase; 

            $scope.editorOptions = {
                lineWrapping: true,
                lineNumbers: true,
                theme: "panda-syntax",
                mode: { name: "javascript", json: true }
            };

            $scope.script = '<iframe src="' + `${formUrlBase}/${apiSpaceId}/forms/${form.id}`  + '" style=" width: 370px;height: 150px;border-radius: 8px;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.21);background-color: #ffffff;padding: 15px 15px 0px 15px; overflow-y: auto;" frameborder=0></iframe>';

            $scope.copyToClipboard = function () {
                var copyTextarea = document.querySelector('.widget-script');
                copyTextarea.select();
                try {
                    document.execCommand('copy');
                    growlService.success('Snippet copied to clipboard');
                } catch (err) {
                    growlService.danger("Snippet not copied, try manualy");
                }
            };

        }]);


})(window.angular);
